/** 资料类型：全部仅用于前端筛选项 */
export type FileTypeFilter = 'all' | 'doc' | 'tool' | 'firmware' | 'other';
export type FileType = Exclude<FileTypeFilter, 'all'>;

/** 上架状态筛选 */
export type EnabledFilter = 'all' | '1' | '0';

/** 菜单树节点（对齐 GET /open-resource/menu） */
export interface MenuNode {
  id: string;
  name: string;
  sort: number;
  children: MenuNode[];
}

/** 设备菜单系列（对齐公开 GET /api/download/device-tree 响应） */
export interface DeviceSeries {
  seriesId: string;
  seriesName: string;
  devices: DeviceMenuItem[];
}

export interface DeviceMenuItem {
  /** 叶子唯一 id，点击后作为列表查询 deviceSeriesId */
  id: string;
  name: string;
}

/** 资源归属设备（对齐 GET /open-resource/file 的 deviceSeriesList） */
export interface DeviceSeriesRef {
  deviceSeriesId: string;
  deviceSeriesName: string;
  seriesName: string;
}

/** 下载资源（对应表 open_download_resource） */
export interface DownloadItem {
  id: string;
  title: string;
  tag: string;
  description: string;
  fileType: FileType;
  /** 兼容保留：归属列表第一项 id */
  deviceSeriesId: string;
  /** 归属设备列表（多型号） */
  deviceSeriesList?: DeviceSeriesRef[];
  fileUrl: string;
  fileName?: string;
  fileSize?: number;
  publishTime: string;
  /** 是否上架；公开 list 仅返回 true */
  enabled: boolean;
  /** 版本号（任务四） */
  version?: string;
  /** 更新日志（任务四） */
  changelog?: string;
  /** 是否强制更新（任务四） */
  forceUpdate?: boolean;
}

/** 列表「归属设备」展示文案 */
export function formatDeviceSeriesList(item: DownloadItem): string {
  const list = item.deviceSeriesList || [];
  if (list.length) {
    return list
      .map(function (row) {
        if (row.seriesName && row.deviceSeriesName) {
          return row.seriesName + ' / ' + row.deviceSeriesName;
        }
        return row.deviceSeriesName || row.deviceSeriesId;
      })
      .join('、');
  }
  return item.deviceSeriesId || '--';
}

/** 从资源行解析型号 id 列表（编辑回填） */
export function getDeviceSeriesIds(item: DownloadItem): string[] {
  const list = item.deviceSeriesList || [];
  if (list.length) {
    return list.map(function (row) {
      return row.deviceSeriesId;
    }).filter(Boolean);
  }
  return item.deviceSeriesId ? [item.deviceSeriesId] : [];
}

export const fileTypeOptions: Array<{ label: string; value: FileTypeFilter }> = [
  { label: '全部', value: 'all' },
  { label: '文档', value: 'doc' },
  { label: '固件', value: 'firmware' },
  { label: '工具', value: 'tool' },
  { label: '其他', value: 'other' },
];

export const fileTypeLabelMap: Record<FileType, string> = {
  doc: '文档',
  tool: '工具',
  firmware: '固件',
  other: '其他',
};

export const enabledFilterOptions: Array<{ label: string; value: EnabledFilter }> = [
  { label: '全部', value: 'all' },
  { label: '已上架', value: '1' },
  { label: '已下架', value: '0' },
];

export function formatFileSize(size?: number): string {
  if (!size || size <= 0) {
    return '--';
  }
  if (size < 1024) {
    return size + ' B';
  }
  if (size < 1024 * 1024) {
    return (size / 1024).toFixed(1) + ' KB';
  }
  return (size / (1024 * 1024)).toFixed(1) + ' MB';
}
